import { useMutation, useQueryClient } from '@tanstack/react-query';
import { api } from './client';
import { ShareInvoicePayload, ShareInvoiceResponse } from './types';

interface ShareInvoiceArgs {
  publicToken: string;
  payload: ShareInvoicePayload;
}

/**
 * Hook to share/unshare an invoice via POST /api/v2/invoices/{id}/share/
 */
export function useShareInvoice() {
  const queryClient = useQueryClient();

  return useMutation<ShareInvoiceResponse, Error, ShareInvoiceArgs>({
    mutationFn: async ({ publicToken, payload }: ShareInvoiceArgs) => {
      const response = await api.post<ShareInvoiceResponse>(
        `/v2/invoices/${publicToken}/share/`,
        payload
      );
      return response.data;
    },
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries({ queryKey: ['invoice', variables.publicToken] });
      queryClient.invalidateQueries({ queryKey: ['invoices'] });
    },
  });
}
